import { useDispatch, useSelector } from "react-redux";
import { setUser } from "../../../redux/ducks/user";
import { ReducersTypes } from "../../../redux/reducers/Models";
import { validateCPF } from "@/utils/functions";
import RegisterView from "./view";
import useRedirect from "../../../hooks/useRedirect";
import { useNavigate } from "react-router-dom";

export default function Register() {
  useRedirect("ticket/user");
  
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const user = useSelector((state: ReducersTypes) => state.userReducer);

  const goBack = () => navigate("/");

  const onChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const {name, value} = e.target;
    dispatch(setUser({ [name]:  value}));
  }

  const getIsDisabled = () => {
    if (!validateCPF(user?.document as string)) return true;
    return false;
  }

  const goToPin = () => {
    if (getIsDisabled()) return;
    
    navigate('/ticket/pin');
  }
  
  return <RegisterView 
    goBack={goBack}
    user={user}
    onChange={onChange}
    goToPin={goToPin}
    isDisabled={getIsDisabled()}
  />;
}
